import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import CoreAppbar from "./CoreAppbar";
import { SET_ROUTE_REDUCER } from "../../store/types/routeTypes";
import {
  api_request,
  setCommonReducer,
} from "../../store/actions/commonAction";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  drawerWidth,
  ENTITY_STATUS,
} from "../../config/constants";
import {
  CHECK_SESSION_ERROR,
  CHECK_SESSION_SUCCESS,
  GET_BASIC_ERROR,
  GET_BASIC_SUCCESS,
} from "../../store/types/authTypes";
import {
  GET_CLIENT_INFO_ERROR,
  GET_CLIENT_INFO_SUCCESS,
  GET_LATEST_PROJECTS_ERROR,
  GET_LATEST_PROJECTS_SUCCESS,
  GET_ROLES_ERROR,
  GET_ROLES_SUCCESS,
  GET_TOOLS_ERROR,
  GET_TOOLS_SUCCESS,
  SETTINGS_META_ERROR,
  SETTINGS_META_SUCCESS,
  USER_SETTINGS_ERROR,
  USER_SETTINGS_SUCCESS,
} from "../../store/types/commonTypes";
import PageContainer from "./PageContainer";
import {
  FETCH_ROLE_PERMISSION_ERROR,
  FETCH_ROLE_PERMISSION_LOADING,
  FETCH_ROLE_PERMISSION_SUCCESS,
} from "../../store/types/rolePermissionTypes";

export default function ProtectedContainer(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const uid = useSelector((state) => state?.auth?.uid);
  const roleId = useSelector((state) => state?.auth?.user?.roleId);
  const nextUrl = useSelector((state) => state?.route?.nextUrl);
  const navigated = useSelector((state) => state?.route?.navigated);
  const initialFetch = useSelector((state) => state?.route?.initialFetch);
  const refreshToken = useSelector((state) => state?.auth?.refreshToken);
  const open = useSelector((state) => state?.common?.sidebarOpen);

  useEffect(() => {
    if (!initialFetch) {
      getRoles();
      getAppConfiguration();
      getBasicProfile();
      getUserConfiguration();
      getRolePermission();
      getMasterData();
      getClientInfo();
      getLatestProjects();
      dispatch({ type: SET_ROUTE_REDUCER, payload: { initialFetch: true } });
    }
  }, []);

  useEffect(() => {
    if (!navigated) {
      dispatch({ type: SET_ROUTE_REDUCER, payload: { navigated: true } });
      navigate(nextUrl);
    }
  }, [nextUrl]);

  useEffect(() => {
    checkSession();
  }, [location?.pathname]);

  const getAppConfiguration = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/settingMeta",
        {},
        {},
        null,
        SETTINGS_META_SUCCESS,
        SETTINGS_META_ERROR,
        true,
        false,
      ),
    );
  };

  const getBasicProfile = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/business/individual/ProfileBasic",
        {},
        {
          _defaultFilter: encodeURIComponent(JSON.stringify({ userId: uid })),
        },
        null,
        GET_BASIC_SUCCESS,
        GET_BASIC_ERROR,
        true,
        false,
      ),
    );
  };

  const getUserConfiguration = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/userSettings",
        {},
        {
          userId: uid,
        },
        null,
        USER_SETTINGS_SUCCESS,
        USER_SETTINGS_ERROR,
        true,
        false,
      ),
    );
  };

  const getRolePermission = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/rolePermission",
        {},
        { roleId: roleId },
        FETCH_ROLE_PERMISSION_LOADING,
        FETCH_ROLE_PERMISSION_SUCCESS,
        FETCH_ROLE_PERMISSION_ERROR,
        true,
        false,
      ),
    );
  };

  const getRoles = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/business/all/Roles",
        {},
        {
          _defaultFilter: encodeURIComponent(
            JSON.stringify({ _status: ENTITY_STATUS.active }),
          ),
        },
        null,
        GET_ROLES_SUCCESS,
        GET_ROLES_ERROR,
        true,
        false,
      ),
    );
  };

  const getClientInfo = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/client/info",
        {},
        {},
        null,
        GET_CLIENT_INFO_SUCCESS,
        GET_CLIENT_INFO_ERROR,
        true,
        false,
      ),
    );
  };

  const getMasterData = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/masterData",
        {},
        {
          name: "tool",
          level: 4,
          _status: "active",
        },
        null,
        GET_TOOLS_SUCCESS,
        GET_TOOLS_ERROR,
        true,
        false,
      ),
    );
  };

  const checkSession = () => {
    if (refreshToken) {
      dispatch(
        api_request(
          API_METHOD_POST,
          "/check/session",
          { refreshToken },
          {},
          null,
          CHECK_SESSION_SUCCESS, //not mentioned in any reducer. this not neede only 401 will logout user
          CHECK_SESSION_ERROR, //not mentioned in any reducer. this not neede only 401 will logout user
          true,
          false,
        ),
      );
    }
  };

  const getLatestProjects = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/projects/latest",
        {},
        {},
        null,
        GET_LATEST_PROJECTS_SUCCESS,
        GET_LATEST_PROJECTS_ERROR,
        true,
        false,
      ),
    );
  };

  const handleOpen = () => {
    dispatch(setCommonReducer({ sidebarOpen: !open }));
  };

  console.log("IN PROTECTED");
  if (
    !uid &&
    location.pathname !== "/" &&
    location.pathname !== "/account/delete"
  ) {
    return <Navigate to="/login" />;
  }

  return (
    <Box
      style={{
        minHeight: "100vh",
        marginTop: "-16px",
        marginLeft: open ? "0px" : `-${drawerWidth}px`,
      }}
    >
      <Box style={{ display: "flex", height: "100%", width: "100%" }}>
        <CoreAppbar open={open} onOpen={handleOpen} />
        <Box
          component="main"
          style={{
            display: "flex",
            height: "100%",
            marginTop: "64px",
            width: "100%",
          }}
        >
          <PageContainer>{props.children}</PageContainer>
        </Box>
      </Box>
    </Box>
  );
}
